import { appStore } from "src/appStore";
import { objectModelVersionStore } from "src/common/objectModelVersionStore";

/**
 * Ключ кэша деталей объекта.
 *
 * restWithObjectVersion добавляет к URL `?v={version}-{userId}-{language}`,
 * поэтому HTTP-кэш переспрашивает backend при смене любого из параметров.
 * Но hydrated-узел в MobX-дереве HTTP-запроса не делает вовсе, и его нужно
 * сравнивать с тем же ключом самостоятельно.
 */
/**
 * Кто сейчас работает.
 *
 * Выход и вход не перезагружают страницу, поэтому стор вкладки переживает смену
 * пользователя вместе с деревом, выбором и кэшами. Отличить нового пользователя
 * можно только сравнением.
 */
export const getCurrentUserKey = (): string =>
  appStore.userData.status === "ready"
    ? String(appStore.userData.result.id)
    : "";

export const getCurrentObjectCacheKey = (): string => {
  const { version } = objectModelVersionStore;
  const userId =
    appStore.userData.status === "ready" ? appStore.userData.result.id : null;
  return `${version ?? "-"}-${userId ?? "-"}-${appStore.curLang}`;
};
